import Chatbot from './components/Chatbot'; // Import the Chatbot component
import React from 'react';
import './App.css';

import {
  Routes,
  Route,
} from "react-router-dom";


import SplashScreen from "./components/SplashScreen/SplashScreen";
import SignInPage from "./pages/SignInPage";
import SignUpPage from "./pages/SignUpPage";
import Employers from './pages/Employers';
import Students from './pages/Students';
import Experience from './components/UserDashboard/Experience';

function App() {
  return(
      <Routes>
        <Route path="/" element={<SplashScreen />} />
        <Route path="/signin" element={<SignInPage />} />
        <Route path="/signup" element={<SignUpPage />} />
        <Route path="/user/experience" element={<Experience />} />
        <Route path="/user/*" element={<Students />} />
        <Route path="/employer/*" element={<Employers />} />
        <Route path="/*" element={<SignInPage />} />
        <Route path="/user/chatbot" element={<Chatbot />} />
      </Routes>
  );
}

export default App;
